import createContext from 'create-react-context/lib/implementation'; // direct implementation has to be used unless enzyme supports React 16 Context API

var _createContext = createContext({}),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

export { Provider, Consumer };